import React from 'react';
import {
  LLWidgetActionInfo,
  LLWidgetActionInfoProps,
  LLWidgetRewardsProps,
} from '../LLWidgetFooter';

function EmptyComponent(_: LLWidgetRewardsProps) {
  return undefined;
}

export function LLPredictionWidgetActionInfo(props: LLWidgetActionInfoProps) {
  return (
    <LLWidgetActionInfo {...props} WidgetRewardsComponent={EmptyComponent} />
  );
}
